import React, { useEffect, useState } from 'react'
import axios from '../../API/axios';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import AttachEmailSharpIcon from '@mui/icons-material/AttachEmailSharp';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import Checkbtn from './Checkbtn';
import jsPDF from 'jspdf';
import ResumePdf from '../Resume/ResumePdf';
import { createRoot } from "react-dom/client";
import html2canvas from 'html2canvas';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
import error from "../../assets/images/No-File-small.png";
import toast from 'react-hot-toast';

const CandidateResume = () => {

	const sessionId = localStorage.getItem("sessionId");
	const UserType = localStorage.getItem("userType");
	const { CandidateId } = useParams();
	//  *******************************     RESUME LISTING   ************************************************

	const [userEducation, setUserEducation] = useState([]);
	const [userAwards, setUserAwards] = useState([]);
	const [userExperience, setUserExperience] = useState([]);
	const [userCertification, setUserCertification] = useState([]);
	const [userDataInfo, setUserDataInfo] = useState([]);
	console.log(userDataInfo, "userDataInfo--------");

	const [projectData, setProjectData] = useState([]);
	const [userSkill, setUserSkill] = useState([]);
	const [isError, setIsError] = useState(false);

	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const userUID = queryParams.get('userUID');
	const InstUID = queryParams.get('InstUID');
 
	const [loading, setLoading] = useState(true); // New state for loading

	const getUserCv = async () => {
		const data = {
			sessionId: sessionId,
			userUID: userUID,
			instnCnddtId: InstUID,
		};
		try {
			const resData = await axios.post(`/CandidateData/Resume`, data);
			setUserDataInfo(resData.data.responseData.userDataInfo);
			setUserEducation(resData.data.responseData.educations);
			setUserAwards(resData.data.responseData.awards);
			setUserExperience(resData.data.responseData.experiences);
			setUserSkill(resData.data.responseData.skills);
			setUserCertification(resData.data.responseData.certifications);
			setProjectData(resData.data.responseData.projects);
		} catch (error) {
			if (error.response && error.response.status === 404) {
				console.log("Error 404: Not Found");
			} else {
				console.error(error);
				setIsError(true);
			}
		} finally {
			setLoading(false); // Ensure loading is set to false after the request completes
		}
	};

	useEffect(() => {
		getUserCv();
	}, []);



	//  *******************************    RESUME LISTING  ************************************************


	const downloadResume = async () => {
		try {
			// Step 1: Create a temporary container for rendering the component
			const tempContainer = document.createElement("div");
			tempContainer.style.position = "absolute";
			tempContainer.style.left = "-9999px"; // Move it offscreen
			document.body.appendChild(tempContainer);

			// Step 2: Create a React root for rendering the ResumePdf component
			const root = createRoot(tempContainer);
			root.render(
				<ResumePdf
					userDataInfo={userDataInfo}  // Make sure userDataInfo includes local image path or proxy URL
					userExperience={userExperience}
					userAwards={userAwards}
					userCertification={userCertification}
					userEducation={userEducation}
					projectData={projectData}
					userSkill={userSkill}
				/>
			);

			// Step 3: Wait for the component to render
			setTimeout(async () => {
				try {
					// Step 4: Generate the canvas from the content
					const canvas = await html2canvas(tempContainer, {
						scale: 1.5,
						useCORS: true,  // Enable CORS if the images are fetched from the same domain
						logging: true,  // Log errors if any occur
						allowTaint: true, // Allow tainted images
					});

					// Step 5: Prepare for PDF generation
					const pdf = new jsPDF("portrait", "pt", "a4");
					const pdfWidth = pdf.internal.pageSize.getWidth();
					const pdfHeight = pdf.internal.pageSize.getHeight();
					const imgWidth = pdfWidth - 40; // Adjust width for 20px padding on left and right
					const pageHeight = pdfHeight - 40; // Adjust height for top and bottom padding

					let yOffset = 0; // Initial offset for content height

					while (yOffset < canvas.height) {
						const portionCanvas = document.createElement("canvas");
						portionCanvas.width = canvas.width;
						portionCanvas.height = Math.min(pageHeight * (canvas.width / imgWidth), canvas.height - yOffset);

						const portionContext = portionCanvas.getContext("2d");
						portionContext.drawImage(
							canvas,
							0,
							yOffset,
							canvas.width,
							portionCanvas.height,
							0,
							0,
							canvas.width,
							portionCanvas.height
						);

						const portionImgData = portionCanvas.toDataURL("image/png");
						pdf.addImage(
							portionImgData,
							"PNG",
							20, // Left padding
							20, // Top padding
							imgWidth,
							(portionCanvas.height * imgWidth) / canvas.width // Maintain aspect ratio
						);

						yOffset += portionCanvas.height; // Increment offset by height of the drawn portion
						if (yOffset < canvas.height) {
							pdf.addPage();
						}
					}

					// Step 7: Save the PDF
					// pdf.save({userDataInfo.fullName});
					const userName = userDataInfo.fullName || "Resume"; // Fallback to "Resume" if fullName is undefined
					const fileName = `${userName}_Resume.pdf`;
					pdf.save(fileName);
				} catch (error) {
					console.error("Error generating PDF:", error.message);
				} finally {
					// Step 8: Clean up the temporary container
					root.unmount();
					document.body.removeChild(tempContainer);
				}
			}, 2000); // Adjust delay as necessary
		} catch (error) {
			console.error("Error generating PDF:", error.message);
		}
	};



	return (
		<>
			{loading ? (
				<div className="mt-6 d-flex justify-content-center">
					<p>Loading...</p> 
				</div>
			) : isError ? (
				<div className="mt-6 d-flex justify-content-center">
					<img src={error} alt="404 Not Found" width={300} />
				</div>
			) : (
				<>
					<div className="profile-resume-main-container pt-3">

						<div className="profile-resume-heading-cont d-flex align-items-center p-4">
							<div className="profile-resume-empty-cont me-2"></div>
							<h2>Profile</h2>
						</div>

						<div className="profile-resume-userinfo mb-3">
							<div className="row p-4">
								<div className="col-md-2">
									<div className="profile-resume-image">
										<img src={userDataInfo.userImage} alt="" srcset="" width={"80%"} />
									</div>
								</div>
								<div className="col-md-7">
									<div className="profile-resume-designation f-14 f-600">
										{userDataInfo.headLine}
									</div>
									<div className="d-flex align-items-center mb-3 Main-resume-username">
										<div className="profile-resume-username me-2">
											{userDataInfo.fullName}
										</div>
									</div>
									<div className="d-flex Resume-Skills-Country-Mobile">
 
										<div className="profile-resume-country d-flex align-items-center">
											{userDataInfo.currentCity === null ? "" : (
												<>
													<div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
														<span class="icon-map-pin me-2"></span>
														{userDataInfo.currentCity}
													</div>
												</>
											)}

										</div>
									</div>
								</div>
								<div className="col-md-3 Manage-Download-Mobile">
									{CandidateId === 'Candidate' ? <Checkbtn /> : ''}

									<div className="edit-profile-btn text-center">
										{UserType === 'Company' || UserType === 'Recruiter' ? '' :
											<Button className="f-13 mt-2  ">
												<Link to={`/ManageResume/${InstUID === null ? 'Candidate' : InstUID}`}>
													Manage
												</Link>
											</Button>}

									</div>
									<div className="edit-profile-btn text-center">
										<Button className="f-13   mt-2" onClick={downloadResume}>
											Download
										</Button>
									</div>

								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-lg-4">

							<div className=" mt-4 mb-2">
								<h6 className="profile-resume-about-heading f-24 f-800 mb-3">Contact</h6>
							</div>
							{userDataInfo?.email === null ? (
								""
							) : (
								<div className="content persnol-info mt-2">
									<div className="d-flex">
										<AttachEmailSharpIcon className="me-2" /> <p>{userDataInfo.email}</p>
									</div>
								</div>
							)}
							{userDataInfo?.dob === null ? (
								""
							) : (
								<div className="content ">
									<div className="d-flex">
										<CalendarMonthSharpIcon className="me-2" /> <p>{userDataInfo.dob}</p>
									</div>
								</div>
							)}
							{userDataInfo?.webSiteLink === null ? (
								""
							) : (
								<div className="content">
									<div className="d-flex">
										<LinkSharpIcon className="me-2" /> <p>{userDataInfo.webSiteLink}</p>
									</div>
								</div>
							)}
							{userDataInfo?.languages?.length > 0 ? (
								<div className="content">
									<div className="d-flex">
										<LanguageSharpIcon className="me-2" />
										{userDataInfo.languages.map((language, index) => (
											<p key={index} className="me-2">
												{language}
											</p>
										))}
									</div>
								</div>
							) : (
								""
							)}
							{userAwards.length === 0 ? (
								""
							) : (
								<>
									<div className="profile-resume-education mt-2">
										<div className="profile-resume-about-heading f-24 f-800 mb-3">
											Awards
										</div>
										{userAwards && userAwards
											.filter((item) => !item.isDeleted)
											.map((item, index) => (
												<div key={item.id || index} className="d-flex">
													<div className="profile-resume-verticle-line me-4"></div>
													<div>
														<div className="profile-resume-education-details mb-3">
															<div className="profile-resume-university f-14 f-700">
																{item.name}  <span className='ms-1 f-13 f-400'>{item.issueDate}  </span>
															</div>
															<div className="profile-resume-education-designation-info f-13 f-400">
															{item.cityName ===null ?'' :(

															<span className='ms-1 me-2 f-13 f-400'> ({item.cityName})</span> 
															)}
																{item.description}
															</div>
														</div>

													</div>
												</div>
											))}

									</div>
								</>
							)}
							{userSkill.length === 0 ? (
								""
							) : (
								<>
									<div className="profile-resume-education mt-2">
										<div className="profile-resume-about-heading f-24 f-800 mb-3">
											Skills
										</div>
										{userSkill && userSkill
											.filter((item) => !item.isDeleted)
											.map((item, index) => (
												<div key={item.id || index} className="d-flex">
													<div className="profile-resume-verticle-line me-4"></div>
													<div>
														<div className="profile-resume-education-details mb-3">
															<div className="profile-resume-university f-14 f-400">
																{item.skillName}
															</div>

														</div>

													</div>
												</div>
											))}

									</div>
								</>
							)}
							{userCertification.length === 0 ? (
								""
							) : (
								<>
									<div className="profile-resume-education mt-2">
										<div className="profile-resume-about-heading f-24 f-800 mb-3">
											Certificates
										</div>
										{userCertification && userCertification
											.filter((item) => !item.isDeleted)
											.map((item, index) => (
												<div key={item.id || index} className="d-flex">
													<div className="profile-resume-verticle-line me-4"></div>
													<div>
														<div className="profile-resume-education-details mb-3">
															<div className="profile-resume-university f-14 f-700">
																{item.name}  <span className='ms-1 f-13 f-400'>{item.issueDate}  </span>
															</div>
															<div className="profile-resume-education-designation-info f-13 f-400"> 
																{item.cityName ===null ?'' :(
                                                                  <span className='ms-1 me-2 f-13 f-400'> ({item.cityName})</span> 
																  )}
																 {item.description}
															</div>
														</div>

													</div>
												</div>
											))}

									</div>
								</>
							)}

						</div>

						<div className="col-lg-8">
							<div className="profile-resume-parent-cont p-4 rounded-4">
								<div className="profile-resume-about">
									{userDataInfo.about === null ? "" : (
										<>
											<div className="profile-resume-about-heading f-24 f-800 mb-3">
												About me
											</div>

											<div className="profile-resume-about-info">
												<p className="f-16 f-400">
													{userDataInfo.about}
												</p>

											</div>
										</>
									)}
								</div>
								{userEducation.length === 0 ? (
									""
								) : (
									<>
										<div className="profile-resume-education">
											<div className="profile-resume-about-heading f-24 f-800 mb-3">
												Education
											</div>
											{userEducation && userEducation
												.filter((item) => !item.isDeleted)
												.map((item) => (
													<div className="d-flex">
														<div className="profile-resume-verticle-line me-4"></div>
														<div>
															<div className="profile-resume-education-details mb-3">
																<div className="profile-resume-university f-14 f-700">
																	{item.institutionName} <span className='ms-2'>{item.startMonth} / {item.startYear} 
																	{item.endYear === "" ? '' : (
																		<>
																	- {item.endMonth} / {item.endYear}
																		</>
																	)}
																		</span>
																</div>
																<div className="profile-resume-education-designation f-16 f-700">
																	{/* {item.institutionName} */}
																</div>
																<div className="profile-resume-education-designation-info f-14 f-400">
																	{item.description}
																</div>
															</div>

														</div>
													</div>
												))}

										</div>
									</>
								)}
								{userExperience.length === 0 ? (
									""
								) : (
									<>
										<div className="profile-resume-education mt-2">
											<div className="profile-resume-about-heading f-24 f-800 mb-3">
												Experience
											</div>
											{userExperience && userExperience
												.filter((item) => !item.isDeleted)
												.map((item, index) => (
													<div key={item.id || index} className="d-flex">
														<div className="profile-resume-verticle-line me-4"></div>
														<div>
															<div className="profile-resume-education-details mb-3">
																<div className="profile-resume-university f-14 f-700">
																	{item.companyName} <span className='ms-2 f-13 f-400'> ({item.cityName})</span>
																</div>
																<div className="profile-resume-education-designation f-16 f-700">
																	<span className='me-2 f-14 f-700'>{item.startDate} 
																		{item.endDate === null ? '' :(
																			<>
																		/ {item.endDate}
																			</>
																		)}
																		 </span>
																</div>
																<div className="profile-resume-education-designation-info f-13 f-400">
																	<span className='me-2 f-14 f-700'>{item.jobTitle}</span> {item.description}
																</div>
															</div>

														</div>
													</div>
												))}

										</div>
									</>
								)}
								{projectData.length === 0 ? (
									""
								) : (
									<>
										<div className="profile-resume-education mt-2">
											<div className="profile-resume-about-heading f-24 f-800 mb-3">
												Projects
											</div>
											{projectData && projectData
												.filter((item) => !item.isDeleted)
												.map((item, index) => (
													<div key={item.id || index} className="d-flex">
														<div className="profile-resume-verticle-line me-4"></div>
														<div>
															<div className="profile-resume-education-details mb-3">
																<div className="profile-resume-university f-14 f-700">
																	{item.name}  <span className='ms-1 f-13 f-400'>{item.startMonth}-{item.startYear} /{item.endMonth}-{item.endYear}  </span>
																</div>
																<div className="profile-resume-education-designation-info f-13 f-400">
																	{item.description}
																</div>
															</div>

														</div>
													</div>
												))}

										</div>
									</>
								)}


							</div>

						</div>
					</div>
				</>
			)}



		</>

	)
}

export default CandidateResume